

























































































































































































































































































































































































import moment from 'moment';
import {
  Vue, Component, Mixins,
} from 'vue-property-decorator';
import {
  CurrencyType,
  FixedAgreement,
  maxDayCreateScoreInMonthNow,
  scoreSource,
} from '@/views/employees/profile/tab-components/score/score-utils';
import { Currency } from '@/domain/employees/entity/professional-data.entity';
import { VbSnackbarService } from 'bag-of-holding-library';
import DateFormat from '@/shared/utils/date-format';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import DatePickerField from '@/shared/date-picker/date-picker-field.component.vue';
import MonthYearSelect from '@/shared/month-year-picker/month-year-select.component.vue';
import CardTitle from '@/shared/card/card-title.component.vue';
import Agreement from '@/domain/employees/entity/agreement.entity';
import ScoreMessage from '@/views/score/score-message.component.vue';
import UpdateAtribute from '@/domain/employees/entity/update-atribute.entity';
import CareerService from '@/domain/employees/service/career.service';
import TooltipIcon from '@/shared/tooltip-icon.component.vue';
import ScoreDependentBenefits from '@/domain/employees/entity/score-dependent-benefits';
import HealthPlanService from '@/domain/health-plan/service/health-plan.service';
import HealthPlanDTO from '@/domain/health-plan/entity/health-plan-DTO';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import ScoreDescriptionRead from '@/views/score/read/score-description-read.component.vue';
import DrdService from '@/domain/drd/service/drd.service';
import Assignment from '@/domain/drd/entity/assignment.entity';
import AgreementComponent from '@/views/employees/profile/tab-components/score/agreement.component.vue';
import DependentBenefitsListComponent from '@/views/employees/profile/tab-components/score/dependent-list.component.vue';
import ScoreDateComponent from '@/views/employees/profile/tab-components/score/score-date.component.vue';
import ScoreBenefitsEmployeeComponent from '@/views/employees/profile/tab-components/score/score-benefits-employee.component.vue';
import Rules from '@/shared/rules/rules';
import CurrencySelect from '@/shared/currency/select/currency-select.component.vue';
import InitialScore from '@/domain/initial-score/entity/initial-score.entity';
import InitialScoreService from '@/domain/initial-score/service/initial-score.service';
import BusinessUnitSelect from '@/shared/business-unit/business-unit-select.component.vue';
import isNullOrUndefined from '@/shared/utils/check-null-or-undefined';
import OperationModality from '@/domain/operation-modality/entity/operation-modality.entity';
import OperationModalitySelect from '@/shared/operation-modality/operation-modality-select.component.vue';
import EmployeeSummary from '@/domain/schedule/employee/employee-summary.entity';
import ResultCenterService from '@/domain/result-center/service/result-center.service';
import EmployeeService from '@/domain/employees/service/employee.service';
import ResultCenter from '@/domain/result-center/entity/result-center.entity';
import ManagerSelect from '@/shared/manager/manager-select.component.vue';
import WorkplaceSelect from '@/shared/workplace/workplace-select.component.vue';
import ResultCenterSelect from '@/shared/result-center/result-center-select.component.vue';
import AddressComponent from '@/shared/address/address.component.vue';
import PhoneComponent from '@/shared/phone/phone.component.vue';
import EmailInput from '@/shared/email/email-input.component.vue';
import EmployeeSelect from '@/shared/employee/employee-select.vue';
import ContractTypes from '@/shared/contract-type/contract-type.json';
import CountrySelect from '@/shared/country-select.component.vue';
import AgreementLimitGuardMixin from '@/shared/agreement-limit/agreement-limit-guard.mixin';
import { ContractType } from '../employees/profile/tab-components/score/contract-type.type';
import UnlockBenefitModal from '../employees/profile/tab-components/score/unlock-benefit-modal.component.vue';
import PdfContentComponent from './pdf-content.component.vue';
import ProjectInput from './components/project-input.component.vue';
import OperationalSystemSelect from './components/operational-system-select.component.vue';
import BusinessUnitSelectOptions from './business-unit-select-options.json';
import ExportDocumentsMenu from './components/export-documents-menu.component.vue';
import BankAccountDocumentBusinessUnitSelectOptions from './bank-account-document-business-unit-select.json';
import InitialScoreObservationComponent from './components/initial-score-observation-component.vue';
import booleanValuesOption from '../employees/profile/tab-components/score/boolean-values-option';

@Component({
  components: {
    DatePickerField,
    LabelSlot,
    MonthYearSelect,
    CardTitle,
    AgreementComponent,
    TooltipIcon,
    DependentBenefitsListComponent,
    ScoreMessage,
    ModalWarning,
    ScoreDescriptionRead,
    ScoreDateComponent,
    ScoreBenefitsEmployeeComponent,
    PdfContentComponent,
    CurrencySelect,
    BusinessUnitSelect,
    OperationModalitySelect,
    ManagerSelect,
    WorkplaceSelect,
    ResultCenterSelect,
    ProjectInput,
    OperationalSystemSelect,
    AddressComponent,
    PhoneComponent,
    EmailInput,
    EmployeeSelect,
    ExportDocumentsMenu,
    InitialScoreObservationComponent,
    CountrySelect,
    UnlockBenefitModal,
  },
  filters: {
    formatDate(value: string) {
      return DateFormat.timestampToLocal(value.split('T')[0]);
    },
  },
})
export default class UpdateInitialScoreComponent extends Mixins(AgreementLimitGuardMixin) {
  score: InitialScore = InitialScore.of({});

  roles: UpdateAtribute[] = [];

  fixedAgreementList: Agreement[] = [];

  variableAgreementList: Agreement[] = [];

  totalAgreementList: Agreement[] = [];

  valid: Boolean = false;

  refs: any = this.$refs

  healthPLanList:HealthPlanDTO[] = [];

  totalAgreement?: Agreement;

  seniorities: any = {};

  rules: Rules = new Rules();

  unlockBenefitManager: boolean = false;

  userLoggedId: string = '';

  showModalWarningUnlockBenefit: boolean = false;

  request = {
    seniorities: [
      {
        value: 'Estagiário',
        disabled: true,
      },
      {
        value: 'Trainee',
        disabled: false,
      },
      {
        value: 'Junior',
        disabled: true,
      },
      {
        value: 'Pleno',
        disabled: false,
      },
      {
        value: 'Sênior',
        disabled: false,
      },
    ],
  }

  loading: boolean = false;

  editPrevious: boolean = false;

  dateFullFormat: string = 'YYYY-MM-DD';

  dateMothYearFormat: string = 'MM/YYYY';

  modalWarningMessage: string = 'Ao salvar o acordo inicial, ele não poderá mais ser editado. Deseja finalizar?';

  loadingSaveButton: boolean = false;

  enableScoreDetailsMessage: boolean = false;

  scoreSource = scoreSource;

  maxDayCreateScoreInMonthNow: number = maxDayCreateScoreInMonthNow();

  FixedAgreementEnum = FixedAgreement;

  assignments: Assignment[] = [];

  messageDetails: string = 'Acesse a aba de remuneração no perfil do colaborador para visualizar o reajuste salarial!';

  currentBusinessUnitCode: number = 0;

  scoreIsRetroactive: boolean = false;

  roleOrSeniorityIsUpdated: boolean = false;

  employeeName: string = '';

  businessUnitOptions = BusinessUnitSelectOptions

  businessUnit: any = {}

  workJourne: string = '44'

  contractType: string = '';

  startDate: string = '';

  alreadyExport: boolean = false;

  currency: Currency = {
    name: 'BRL',
    description: 'Real',
    symbol: 'R$',
  };

  constractTypes = ContractTypes;

  operationModality: OperationModality = new OperationModality();

  lastBusinessUnit: string = '';

  loadingResultCenter: boolean = false;

  resultCenters: ResultCenter[] = [];

  disabledOperationModality: boolean = false;

  countryIsBrazil: boolean = false;

  businessUnitBankAccountDocument: any = {};

  businessUnitBankAccountDocumentOptions = BankAccountDocumentBusinessUnitSelectOptions;

  booleanValuesOption = booleanValuesOption;

  async created() {
    this.$destroy();
    this.loading = true;
    await this.getInitialScoreById();
    this.setListOfAgreement();
    await this.getUserLogged();
    await this.getInitialData();
    this.setScoreInitialData();
  }

  setScoreInitialData() {
    this.score.unscheduledScore = false;
    if (!isNullOrUndefined(this.score.currency)) {
      this.currency = this.score.currency;
    }
    this.setCountDate();
  }

  setCountDate() {
    this.score.countDate = moment().format(this.dateFullFormat);
  }

  applyReadJustmentPeriod(value: string) {
    this.score.readjustmentPeriod = value;
  }

  clearNextCountDate() {
    this.score.nextCountDate = '';
  }

  save() {
    const { form }: any = this.refs;
    if (!form.validate()) {
      VbSnackbarService.showError('Por favor, preencha todos os campos obrigatórios!');
      return;
    }
    this.score.total();
    if (this.isLimitBenefitUnlock) {
      this.openModalUnlockBenefitManager();
      return;
    }
    this.loadingSaveButton = true;
    this.updateInitialScore(this.score.toRequest());
  }

  updateInitialScore(score: InitialScore) {
    score.agreementList.forEach((agreement) => {
      agreement.previousAgreement = agreement.newAgreement
    })
    InitialScoreService.update(score)
      .then(() => {
        VbSnackbarService.showSuccess('Acordo inicial atualizado com sucesso!');
      })
      .catch((err: any) => {
        VbSnackbarService.handleHttpError(err);
      }).finally(() => this.loadingSaveButton = false);
  }

  setListOfAgreement() {
    this.fixedAgreementList = [];
    this.variableAgreementList = [];
    this.totalAgreementList = [];

    const fixedValuesAgreement = [
      this.FixedAgreementEnum.SALARY_IN_CLT,
      this.FixedAgreementEnum.DUCZ,
      this.FixedAgreementEnum.DUCZ_SYNDICATE_FREE,
      this.FixedAgreementEnum.EDUCATION_SUBSIDY_ASSISTANCE,
      this.FixedAgreementEnum.EDUCATION_SUBSIDY_DEPENDENT,
    ];
    const fixedCareerAgreement = [
      this.FixedAgreementEnum.ASSIGNMENT,
      this.FixedAgreementEnum.ROLE,
      this.FixedAgreementEnum.SENIORITY,
    ];
    const fixedAgreement = [
      ...fixedCareerAgreement,
      ...fixedValuesAgreement,
      this.FixedAgreementEnum.TOTAL,
    ];

    fixedAgreement.forEach((descrition) => {
      this.score.agreementList.forEach((it) => {
        if (it.description === descrition && descrition !== this.FixedAgreementEnum.TOTAL) {
          this.fixedAgreementList.push(it);
        }
      })
    })

    this.variableAgreementList = this.score.agreementList
      .filter(it => !fixedAgreement.some(description => description === it.description));

    this.totalAgreementList = this.score.agreementList
      .filter(it => it.description === this.FixedAgreementEnum.TOTAL);
  }

  updateHealthPlanEmployee(value: boolean) {
    this.score.healthPlanEmployee = value;
    if (!value) {
      this.score.benefitObservation = '';
      this.score.healthPlanEmployeePayedByDB1 = false;
      this.score.healthPlan.healthPlanType = '';
    }
  }

  updateDentalPlanEmployee(value: boolean) {
    this.score.dentalPlanEmployee = value;
    if (!value) {
      this.score.dentalPlanEmployeePayedByDB1 = false;
    }
  }

  addDependent() {
    const dependent = ScoreDependentBenefits.of({})
    this.score.dependentBenefits.push(dependent)
  }

  addNewAgreement() {
    const total = this.score.agreementList.pop();
    this.score.agreementList.push(Agreement.of({ previousAgreement: 'NOT_EXISTS' }));
    if (total !== undefined) {
      this.score.agreementList.push(total);
    }
    this.setListOfAgreement();
  }

  removeAgreement(item: Agreement) {
    const index = this.score.agreementList.indexOf(item);
    this.score.agreementList.splice(index, 1);
    this.setListOfAgreement();
    this.updateTotal();
  }

  removeDependent(item: ScoreDependentBenefits) {
    const index = this.score.dependentBenefits.indexOf(item);
    this.score.dependentBenefits.splice(index, 1);
  }

  updateTotal() {
    this.score.total();
  }

  healthPLan(type: string): void {
    this.healthPLanList.forEach((it) => {
      if (it.healthPlanType === type) {
        this.score.healthPlan = HealthPlanDTO.of({});
        this.score.healthPlan = it;
      }
    })
  }

  updateHealthPlanEmployeePayedByDB1(healthPlanPayedByDB1: boolean): void {
    this.score.healthPlanEmployeePayedByDB1 = healthPlanPayedByDB1;
    if (healthPlanPayedByDB1) {
      this.healthPLan('REGION_INFIRMARY');
      return;
    }
    this.score.healthPlan.healthPlanType = '';
  }

  private setTotalAgreement(): void {
    if (!this.score) return;
    this.totalAgreement = this.score.agreementList
      .find((agreement: Agreement) => agreement.description === this.FixedAgreementEnum.TOTAL);
    this.score.agreementList = this.score.agreementList
      .filter((agreement: Agreement) => agreement.description !== this.FixedAgreementEnum.TOTAL);
  }

  getHealthPlanList() {
    HealthPlanService.getHealthPLanList().then((resp) => {
      this.healthPLanList = HealthPlanDTO.ofList(resp)
    })
  }

  getRoles() {
    CareerService.getRoles().then((resp: any) => this.roles = resp.data);
  }

  getSeniorities() {
    CareerService.getSeniority().then((resp: any) => {
      this.seniorities = resp.data;
      resp.data.forEach((respSeniority) => {
        this.request.seniorities.push(
          {
            value: respSeniority.name,
            disabled: false,
          },
        )
      });
    });
  }

  getAssignments() {
    DrdService.getAssigments().then((response: Assignment[]) => this.assignments = response);
  }

  async getInitialData() {
    Promise.all([
      this.getRoles(),
      this.getHealthPlanList(),
      this.getSeniorities(),
      this.getAssignments(),
      this.getResultCenters(),
      this.getUnlockBenefitManager(),
      this.loadAgreementLimit('INITIAL', this.selectedRoleIsLeader),
    ]).finally(() => {
      this.loading = false;
    });
  }

  get selectedRoleIsLeader(): boolean {
    const selectedRole = this.roles.find(role => role.name === this.roleName);
    return selectedRole ? selectedRole.leader : false;
  }

  onRoleNameChange(roleName: string) {
    const selectedRole = this.roles.find(role => role.name === roleName);
    this.loadAgreementLimit('INITIAL', selectedRole ? selectedRole.leader : false);
  }

  get senioritySorted() {
    return this.request.seniorities.sort((seniority1, seniority2) => {
      if (seniority1.value < seniority2.value) return -1;
      if (seniority1.value > seniority2.value) return 1;
      return 0;
    })
  }

  get scoreCountDate() {
    return moment(this.score.countDate).format('DD/MM/YYYY');
  }

  back() {
    window.history.go(-1)
  }

  updateDentalPlanEmployeePayedByDB1(value: boolean) {
    this.score.dentalPlanEmployeePayedByDB1 = value;
  }

  updateLifeInsuranceEmployee(value: boolean) {
    this.score.lifeInsuranceEmployee = value;
  }

  updateBenefitObservation(value: string) {
    this.score.benefitObservation = value;
  }

  get ducz() {
    if (this.score.containsDuczSyndicate) {
      return this.fixedAgreementList
        .filter(it => it.description === this.FixedAgreementEnum.DUCZ)[0].newAgreementValue
        + this.fixedAgreementList
          .filter(it => it.description === this.FixedAgreementEnum.DUCZ_SYNDICATE_FREE)[0]
          .newAgreementValue
    }
    return this.fixedAgreementList
      .filter(it => it.description === this.FixedAgreementEnum.DUCZ)[0].newAgreementValue
  }

  get educationSubsidy() {
    return this.fixedAgreementList
      .filter(it => it.description === this.FixedAgreementEnum.EDUCATION_SUBSIDY_ASSISTANCE)[0]
      .newAgreementValue
  }

  get salary() {
    return this.fixedAgreementList
      .filter(it => it.description === this.FixedAgreementEnum.SALARY_IN_CLT)[0].newAgreementValue
  }

  get roleName(): string {
    const role = this.fixedAgreementList
      .find(it => it.description === this.FixedAgreementEnum.ROLE);
    return role ? role.newAgreement : '';
  }

  get seniority() {
    return this.fixedAgreementList
      .filter(it => it.description === this.FixedAgreementEnum.SENIORITY)[0].newAgreement
  }

  get contractTypeObject(): ContractType | undefined {
    return this.constractTypes
      .find((contractType: ContractType) => contractType.name === this.score.contractType);
  }

  updateAgreement() {
    if (
      !this.score.containsDuczSyndicate
      && this.score.currency.name === CurrencyType.BRL
      && (this.score.contractType === 'CLT' || this.score.contractType === 'PJ')
    ) {
      this.score.addDuczSyndicate();
      this.setListOfAgreement();
      return;
    }
    if (this.score.containsDuczSyndicate && (this.score.contractType === 'YOUNG_APPRENTICE' || this.score.contractType === 'INTERNSHIP')) {
      this.score.removeDuczSyndicate();
      this.setListOfAgreement();
      return;
    }
    if (this.score.containsDuczSyndicate
    && (this.score.contractType === 'CLT' || this.score.contractType === 'PJ')
    && this.score.currency.name !== CurrencyType.BRL) {
      this.score.removeDuczSyndicate();
      this.setListOfAgreement();
    }
  }

  updateCurrency(currency: Currency) {
    this.score.currency = currency;
    this.currency = currency;
    this.updateAgreement();
  }

  updateContractType(contractType: string) {
    this.score.contractType = contractType;
    this.updateAgreement();
  }

  async getInitialScoreById() {
    await InitialScoreService.getById(this.$route.params.id)
      .then(response => this.score = response)
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
        window.history.go(-1);
      })
      .finally(() => this.loading = false)
  }

  changeOperationModality(operationModality: OperationModality) {
    this.score.operationModality = operationModality;
  }

  updateWorkplace(workplaceSelected: any) {
    this.score.workplace = workplaceSelected.id;
    if (workplaceSelected.defaultOperationModality) {
      this.score.operationModality = workplaceSelected.defaultOperationModality;
      this.disabledOperationModality = true;
      return
    }
    this.score.operationModality = new OperationModality();
  }

  getResultCenters() {
    this.loadingResultCenter = true;
    ResultCenterService.getResultCentersByBusinessUnitId(this.score.businessUnitId)
      .then(resp => this.resultCenters = resp)
      .finally(() => this.loadingResultCenter = false);
  }

  updateBusinessUnit(businessUnitId: string) {
    if (this.score.businessUnitId === businessUnitId) return;
    this.score.businessUnitId = businessUnitId;
    this.lastBusinessUnit = businessUnitId;
    this.getResultCenters();
  }

  updateManager(manager: EmployeeSummary) {
    this.score.manager = manager;
    this.updateBusinessUnit(manager.businessUnit.id!)
  }

  updateAddressFields(field: string, value: any) {
    this.score.address[field] = value;
  }

  get noDataTextResultCenter(): string {
    if (!this.score.businessUnitId) return 'Por favor, informe a unidade';
    return this.resultCenters.length === 0 ? 'Nenhum centro de custo encontrado' : '';
  }

  get isLimitBenefitUnlock(): boolean {
    return this.score.isUnlockedBenefitLimit(this.maxBenefitRatio)
    || this.score.isUnlockedTotalLimit(this.maxTotalMultiplier)
    || this.score.isUnlockedDuczSyndicateFree(this.maxDuczSyndicateRatio)
    || this.score.isUnlockedDuczFreeMinimum(
      this.agreementLimit ? this.agreementLimit.duczFreeMinimumValue : 0,
    )
    || this.score.isUnlockedDuczFoodMaximum(
      this.agreementLimit ? this.agreementLimit.duczFoodMaximumValue : 0,
    );
  }

  closeModalUnlockBenefit(): void {
    this.showModalWarningUnlockBenefit = false;
  }

  openModalUnlockBenefitManager(): void {
    this.showModalWarningUnlockBenefit = true;
  }

  sendEmailToHR() {
    this.showModalWarningUnlockBenefit = false;
    this.updateInitialScore(this.score.toRequest());
  }

  async getUnlockBenefitManager() {
    await EmployeeService.getProfessionalDataUserLoggedInSimplified()
      .then((resp: any) => {
        this.unlockBenefitManager = resp.unlockBenefitManager;
      });
  }

  async getUserLogged(): Promise<void> {
    this.userLoggedId = await EmployeeService.getLoggedUserEmployeeId();
  }
}
